import { useEffect, useRef } from 'react';
var useInterval = function (callback, delay, immediate) {
    if (immediate === void 0) { immediate = false; }
    var savedCallback = useRef(callback);
    if (immediate) {
        useEffect(callback, []);
    }
    useEffect(function () {
        savedCallback.current = callback;
    }, [callback]);
    useEffect(function () {
        if (delay !== null) {
            var timer_1 = setInterval(savedCallback.current, delay);
            return function () { return clearInterval(timer_1); };
        }
    }, [delay]);
};
export default useInterval;
